export function gtag_report_conversion() {
  typeof window !== 'undefined' &&
    window.gtag('event', 'conversion', {
      send_to: 'AW-481819342/y-dmCOunw8ADEM713-UB',
    })
}
